const PagesNav = require('../../../../js/PagesNav');
const {
	trackDownload,
	trackGtm4,
	disableStaticURL,
} = require('../../../../js/functions');

const SELECTOR_TITLE = '.document-list--title';
const SELECTOR_DOWNLOAD = '.document-list--download';
const SELECTOR_PAGES = '.document-list--pages';
const SELECTOR_PAGE = '.document-list--page';
const SELECTOR_ROW = '.document-row';
const SELECTOR_ROW_TITLE = '.document-row--title';
const CLASS_CLOSE_BTN = '.document-list--close';
const CLASS_MODAL = '.document-list--warning';
const CLASS_DOWNLOAD_ALL = '.document-list--download-label';
const CLASS_NOTE = '.document-list--notes';
const CLASS_PAGE_FIRST = '.pages-nav--first';
const CLASS_PAGE_LAST = '.pages-nav--last';

module.exports = {
	...PagesNav,
	init() {
		this.closeError = this.root.querySelector(CLASS_CLOSE_BTN);
		this.title = this.root.querySelector(SELECTOR_TITLE);
		this.initialize(this.root, SELECTOR_PAGE, SELECTOR_PAGES, true, this.title);
		this.downloadBtn = this.root.querySelector(SELECTOR_DOWNLOAD);
		this.documentListPages = this.root.querySelector(SELECTOR_PAGES);
		this.note = this.root.querySelector(CLASS_NOTE);
		this.pageNavFirst = this.root.querySelector(CLASS_PAGE_FIRST);
		this.pageNavLast = this.root.querySelector(CLASS_PAGE_LAST);
		this.initEvents();

		this.pageNavFirst?.addEventListener('click', () => {
			this.ga4Tracking(this.title, this.pageNavFirst);
		});

		this.pageNavLast?.addEventListener('click', () => {
			this.ga4Tracking(this.title, this.pageNavLast);
		});
	},
	ga4Tracking(title, link) {
		trackGtm4({
			event: 'GA4_event_c_content_navigation_click',
			widget_name: 'V3-Investor-key-docs',
			widget_title: title ? title.innerHTML.trim() : 'No title',
			widget_type: 'document',
			link_text: link ? link.innerHTML.trim() : 'No text',
			link_url: 'No url',
			interaction_type: link ? link.innerHTML.toLowerCase().trim() : 'No text',
		});
	},
	initEvents() {
		if (this.downloadBtn) {
			this.downloadBtn.addEventListener('click', event => {
				event.stopPropagation();
				const downloadAllLabel = this.title
					? this.root.querySelector(CLASS_DOWNLOAD_ALL)?.innerHTML
					: event.currentTarget.getAttribute('aria-label');
				const href = event.currentTarget.href;
				const title = this.title
					? this.title.innerHTML
					: this.note?.firstChild.nodeValue.trim();
				trackGtm4({
					event: 'GA4_event_c_file_download',
					file_name: href.split('/').pop(),
					widget_name: this.root.dataset.widgetName,
					widget_title: title,
					link_url: href,
					link_text: downloadAllLabel,
					title: title,
				});
				trackDownload(title, href);
			});
		}
		if (this.closeError)
			this.closeError.addEventListener('click', this.hideWarning.bind(this));

		this.documentListPages.addEventListener('click', event => {
			event.stopPropagation();
			const clickedEl = event.target;
			if (clickedEl.download !== undefined) {
				const href = clickedEl.href;
				const title = clickedEl
					.closest(SELECTOR_ROW)
					.querySelector(SELECTOR_ROW_TITLE).textContent;

				trackGtm4({
					event: 'GA4_event_c_file_download',
					file_name: href.split('/').pop(),
					widget_name: this.root.dataset.widgetName,
					widget_title: title,
					link_url: href,
					link_text: this.root.dataset.downloadLabel,
					title: title,
				});
				trackDownload(title, href);
				disableStaticURL(clickedEl, 'download-disabled');
			}
		});
	},
	hideWarning() {
		const modalError = this.root.querySelector(CLASS_MODAL);
		modalError.style.display = 'none';
	},
};
